import { useEffect, useState } from "react";
import saleYellow from "../../assets/courses/saleYellow.png";

import { Link } from "react-router-dom";


const ExploreCourses = () => {
  const [filter, setFilter] = useState(""); // Default to the first category
  const [categories, setCategories] = useState([]); // Dynamically fetched categories
  const [categoriesData, setCategoriesData] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/explore-our-course`
        );
        const data = await response.json();

        if (data && Array.isArray(data)) {
          setCategoriesData(data); // Store the full data

          // Dynamically extract category names and set the initial filter
          const fetchedCategories = data.map((category) => category.name);
          setCategories(fetchedCategories);
          // console.log(fetchedCategories);
          setFilter(fetchedCategories[0]); // Default filter
          setFilteredCourses(data[0]?.programs || []); // Default programs
        }
        console.log();
      } catch (error) {
        console.error("Failed to fetch courses:", error);
      }
    };

    fetchCourses();
  }, []);

  console.log("fil", filteredCourses);
  const handleFilterChange = (categoryName) => {
    setFilter(categoryName);
    const selectedCategory = categoriesData.find(
      (category) => category.name === categoryName
    );
    setFilteredCourses(selectedCategory?.programs || []);
  };


  return (
    <div className="mx-auto max-w-[1380px]">
    {/* Categories Section */}
    <div className="mx-auto max-w-[1380px]">
      <div className="flex justify-center mt-6 mb-2 max-sm:text-md flex-wrap lg:space-x-2 px-4">
        <div className="w-full max-w-fit rounded-full px-3 py-2 flex flex-wrap justify-center gap-2
          bg-transparent md:bg-transparent lg:bg-[#c9dbff73]">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => handleFilterChange(category)}
              className={`px-4 py-2 text-[16px] rounded-full border transition-all duration-300 ease-in-out
                ${
                  filter === category
                    ? "text-[#04236B] border-[#04236B] font-semibold"
                    : "text-[#848383] border-transparent hover:text-[#04236B] hover:border-[#04236B]"}
          `}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>
      {/* Filtered Courses Section */}
      <div className="w-[98%] lg:w-[94%] mx-auto">
        <h1 className="text-24 text-[#04236B] font-medium	 md:text-left lg:text-left mb-2">
          {filter}
        </h1>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mx-auto">
          {filteredCourses.map((program, index) => (
            <Card program={program} key={program.programId || index} />
          ))}
        </div>
      </div>

      {/* Explore More Button */}
      <div className="my-12 lg:flex justify-end hidden pr-8">
        <div className="flex items-center gap-3 group cursor-pointer">
          <span className="text-[#04236B] font-semibold text-lg">
            Explore more courses
          </span>
          <Link to="/ExploreOurCourses">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-[#04236B] transition-transform duration-300 group-hover:translate-x-1">
              <svg
                className="w-4 h-4 text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ExploreCourses;
function getTwoDaysFromNow() {
  const today = new Date();
  const twoDaysLater = new Date(today);
  twoDaysLater.setDate(today.getDate() + 2);
  // Format the date as desired (e.g., "Jan 13, 2025")
  const options = { year: "numeric", month: "short", day: "numeric" };
  return twoDaysLater.toLocaleDateString("en-US", options);
}

function Card({ program }) {
  // console.log("program:",program)
  return (
    <div className="  bg-white flex flex-col shadow-lg rounded-lg p-4 w-full ">
      {/* Image Section with Rating */}
      <div className="relative mb-4">
        {program.discount && (
          <img
            src={saleYellow}
            className="absolute z-30 h-24 w-24 right-0 top-0"
            alt="Discount Badge"
          />
        )}

        <div className="relative">
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}/university/image/${program?.universityId}.jpg`}
            alt="University"
            className="w-full h-48 rounded-md object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b rounded-md from-[rgba(0,0,0,0.6)] to-transparent opacity-60"></div>
          <div className="absolute inset-0 bg-gradient-to-t rounded-md from-[rgba(0,0,0,0.8)] to-transparent opacity-60"></div>

          {/* Rating Badge */}
          <span className="absolute z-30 bg-[#FFF3E0] text-[#FF9900] text-xs font-semibold px-3 py-1 rounded-full top-2 right-2 flex items-center">
            {program.universityRating}
            {/* Star Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              width="12"
              className="ml-1"
              fill="#FF9900"
            >
              <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
            </svg>
          </span>
        </div>
      </div>

      {/* Card Content Section */}
      <div className="flex flex-col justify-between text-left gap-2 p-4">
        {/* University Name */}
        <p
          className="text-[#04236B] font-semibold text-[14px] mb-2"
          style={{
            backgroundColor: "#c9dbff73",
            padding: "4px 8px",
            borderRadius: "5px",
            maxWidth: "fit-content", 
          }}
        >
          {program.universityName}
        </p>

        {/* Program Name */}
        <h1 className="text-[#262626] font-medium	 text-lg mb-2">{program.programName}</h1>

        {/* Degree Duration and Application Due */}
        <p className="text-[#999999] text-[14px]font-semibold mb-2">
          Degree Duration: {program.duration}
        </p>
        <p className="text-[#999999] text-[14px]font-semibold mb-4">
          Application Due: {getTwoDaysFromNow()}
        </p>

        {/* Buttons Section */}
        <div className=" w-full flex flex-col md:flex-row justify-between relative mt-2 gap-4 ">
          {/* Syllabus Button */}
          <button
            className="w-full primary-small-Btn-HollowScale px-8 py-2 transition-all duration-200 transform hover:scale-105"
          >
            Syllabus
          </button>

          {/* Enroll Now Button */}
          <button
            className=" w-full primary-small-Btn-fillScale flex items-center justify-center px-8 py-2 transition-all duration-200 transform hover:scale-105"
          >
            Enroll Now
            <svg
              className="ml-1 w-4 h-4 inline-block"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>

  );
}

